import React, { useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { useAppDispatch } from "../../../../../application/store";
import { ColorsRepository } from "../../../../../domain";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";
import { loadColors } from "../../../../../application/colors-slice";

type NewColorModalProps = {
  visible: boolean;
  onClose: () => void;
};

const NewColorModal: React.FC<NewColorModalProps> = ({ visible, onClose }) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [color, setColor] = useState<string>();

  const submit = async () => {
    try {
      await form.validateFields();
      if (color === undefined) return;
      setIsLoading(true);
      const categoriesRepository = ServiceLocater.get<ColorsRepository>(
        Services.ColorsRepository
      );
      const res = await categoriesRepository.add(
        form.getFieldValue("title"),
        color
      );
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          message.success("رنگ با موفقیت ایجاد شد");
          dispatch(loadColors());
          onClose();
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      title={"رنگ جدید"}
      visible={visible}
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={isLoading ? undefined : onClose}
      onOk={submit}
      confirmLoading={isLoading}
      bodyStyle={{ paddingBottom: 0 }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label="نام رنگ"
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input name="title" />
        </Form.Item>
        <Form.Item
          name="color"
          label="رنگ"
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input
            name="color"
            type="color"
            onChange={(e) => setColor(e.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default NewColorModal;
